module.exports = {"title":"Export","exportXls":"Export portfolio to XLS"}